import { FC } from "react"
import { PhoneCallsTable } from "src/components/pages/phone-calls"

export const PhoneTab: FC = () => {
  return <PhoneCallsTable />
}
